import { render, staticRenderFns } from "./index.vue?vue&type=template&id=106cc563&scoped=true&"
import script from "./editProfile.js?vue&type=script&lang=js&"
export * from "./editProfile.js?vue&type=script&lang=js&"
import style0 from "./editProfile.scss?vue&type=style&index=0&id=106cc563&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106cc563",
  null
  
)

export default component.exports